import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { getTickets, deleteTicket } from '../../../../api/ticket'
import {
  Button,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'
import {
  mapSugerenciasRows,
  filterSugerenciasTickets,
} from './ticketTableUtils'

export default function SugerenciasPage() {
  const [data, setData] = useState([])
  const [ticketId, setTicketId] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [statusFilter, setStatusFilter] = useState('')
  const [dateFrom, setDateFrom] = useState('')
  const [dateTo, setDateTo] = useState('')
  const [search, setSearch] = useState('')
  const history = useHistory()

  function buttonFormatter(cell) {
    return (
      <>
        <Tooltip title="Edit">
          <Button style={buttonsStyle} size="small" onClick={() => history.push('/edit-sugerencia/' + cell)}>
            <EditIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Delete">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setTicketId(cell)
              setOpenConfirmDialog(true)
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    )
  }

  const columns = [
    { dataField: 'ref', text: 'Ref', sort: true },
    { dataField: 'title', text: 'Título', sort: true },
    { dataField: 'status', text: 'Estado', sort: true },
    { dataField: 'email', text: 'Email', sort: true },
    { dataField: 'createdAt', text: 'Creado', formatter: dateFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter },
  ]

  useEffect(() => {
    const params = { kind: 'suggestion' }
    if (statusFilter) params.status = statusFilter
    getTickets(params)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data)
          setRefresh(false)
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudieron cargar las sugerencias.' })
      })
  }, [refresh, statusFilter])

  const filtered = useMemo(
    () =>
      filterSugerenciasTickets(data, {
        dateFrom,
        dateTo,
        search,
      }),
    [data, dateFrom, dateTo, search],
  )

  return (
    <Card>
      <CardHeader title="Buzón de sugerencias" />
      <CardBody>
        <div style={{ display: 'flex', gap: 16, marginBottom: 16, flexWrap: 'wrap' }}>
          <FormControl variant="outlined" size="small" style={{ minWidth: 160 }}>
            <InputLabel>Estado</InputLabel>
            <Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              label="Estado"
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="pending">Pendiente</MenuItem>
              <MenuItem value="in_progress">En trámite</MenuItem>
              <MenuItem value="resolved">Resuelta</MenuItem>
              <MenuItem value="cancelled">Cancelada</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Desde"
            type="date"
            size="small"
            variant="outlined"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            InputLabelProps={{ shrink: true }}
            style={{ minWidth: 150 }}
          />
          <TextField
            label="Hasta"
            type="date"
            size="small"
            variant="outlined"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            InputLabelProps={{ shrink: true }}
            style={{ minWidth: 150 }}
          />
          <TextField
            label="Buscar (ref, email, título…)"
            size="small"
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ minWidth: 220 }}
          />
        </div>
        <Table data={mapSugerenciasRows(filtered)} columns={columns} />
        <ConfirmDialog
          title="¿Eliminar esta sugerencia?"
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteTicket(ticketId)
              .then((res) => {
                if (res.status === 200 || res.status === 204) {
                  alertSuccess({ title: 'Eliminado', customMessage: 'Sugerencia eliminada.' })
                  setRefresh(true)
                }
              })
              .catch((error) => {
                alertError({ error, customMessage: 'No se pudo eliminar.' })
              })
          }}
        />
      </CardBody>
    </Card>
  )
}
